<template lang="pug">
  b-card
    b-row
      .col-xl-12
        operatorBetLimitSettings(ref="operatorBetLimitSettings" :loading="loading")
        SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=false type="button" @click="submit" :disabled="loading")
        
</template>
<script>
import config from "@/config"
import {
  required,
  minValue,
  maxValue,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  alphaNum,
  helpers,
  requiredIf
} from "vuelidate/lib/validators"
import SubmitButton from "@/library/SubmitButton"
import ValidateResult from "@/library/ValidateResult"
import DebounceInput from "@/library/DebounceInput"
import operatorBetLimitSettings from "@/components/betLimit/operatorBetLimitSettings.vue"
export default {
	components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    operatorBetLimitSettings
	},
	data() {
    return {
			loading: false,
			submission: {
        success: true,
        status: ""
      },
			blJSON: {
        soccer_min_bet: 0,
        soccer_max_bet: 0,
        soccer_max_per_match: 0,
        basketball_min_bet: 0,
        basketball_max_bet: 0,
        basketball_max_per_match: 0,
        tennis_min_bet: 0,
        tennis_max_bet: 0,
        tennis_max_per_match: 0,
        baseball_min_bet: 0,
        baseball_max_bet: 0,
        baseball_max_per_match: 0,
        parlay_min_bet: 0,
        parlay_max_bet: 0,
        parlay_max_per_match: 0,
        esports_min_bet: 0,
        esports_max_bet: 0,
        esports_max_per_match: 0,
        others_min_bet: 0,
        others_max_bet: 0,
        others_max_per_match: 0,
        cs_min_bet: 0,
        cs_max_bet: 0,
        cs_max_per_match: 0,
      },
    };
	},
	methods: {
		formBlJson: function() {
			let allRefs = this.$refs.operatorBetLimitSettings.$refs;
      for (var ref in allRefs) {
				if(ref != 'hdp_package'){
					this.blJSON[ref] = this.$helpers.convertNumber(this.$refs.operatorBetLimitSettings[ref]);
				}else{
					this.blJSON[ref] =this.$refs.operatorBetLimitSettings[ref];
				}
      }
    },
		submit(){
			if (!this.isValidForm()) {
        this.loading = true;
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_bet_limit_setting"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateBetLimit();
          } else if (
            // Read more about handling dismissals
            result.dismiss === "cancel"
          ) {
            this.loading = false;
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_bet_limit_setting_cancel"),
              type: "error"
            }).then(isConfirm => {
              if (isConfirm) {
                this.loading = false;
              }
            });
          }
        });
      }
		},
		isValidForm() {
      this.$refs.operatorBetLimitSettings.$v.$touch()
      // this.$v.$touch()

      return (
        this.$refs.operatorBetLimitSettings.$v.$invalid
      );
		},
		updateBetLimit(){
			this.formBlJson();
			let bl = this.blJSON;
			// console.log(bl);
			this.$store
        .dispatch("user/updateOperatorBetLimit", {
          bl
        })
        .then(response => {
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            this.$swal({
							title: this.$t("ui.succeed"),
							text: this.$t("message.update_bet_limit_succeed"),
							type: "success",
							allowOutsideClick: false
						}).then(isConfirm => {
							if (isConfirm) {
								this.loading = false;
							}
						});
          } else {
            this.loading = false
            this.$swal(this.$t("ui.fail"), this.$t("message." + response.errorTag), "error")
            return;
          }
        })
        .catch(response => {
          // console.log(response)
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
          this.$swal(this.$t("ui.fail"), this.$t("message." + response.errorTag), "error")
        });
		},
		cancel: function() {
      this.$router.push("/editBetLimit");
    }
	}
}
</script>
